import { create } from "zustand";
import type { Company } from "@/services/companyApi";

interface CompanyUIState {
  searchTerm: string;
  isFormOpen: boolean;
  selectedCompany: Company | null;
  formLoading: boolean;
  setSearchTerm: (value: string) => void;
  openCreateForm: () => void;
  openEditForm: (company: Company) => void;
  closeForm: () => void;
  setFormLoading: (value: boolean) => void;
}

export const useCompanyUIStore = create<CompanyUIState>((set) => ({
  searchTerm: "",
  isFormOpen: false,
  selectedCompany: null,
  formLoading: false,
  setSearchTerm: (value) => set({ searchTerm: value }),
  openCreateForm: () => set({ isFormOpen: true, selectedCompany: null }),
  openEditForm: (company) =>
    set({ isFormOpen: true, selectedCompany: company }),
  closeForm: () => set({ isFormOpen: false, selectedCompany: null }),
  setFormLoading: (value) => set({ formLoading: value }),
}));
